import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import NotFoundView from './components/404.vue'

// Import Views - Dash
import DashboardView from './components/views/Dashboard.vue'
import SolicitudView from './components/views/Solicitud.vue'
import IndividualView from './components/views/Individual.vue'
import SearchView from './components/views/Search.vue'
import BuyOrdersView from './components/views/BuyOrders.vue'
import BillsManagementView from './components/views/BillsManagement.vue'
import ChangePswView from './components/views/ChangePsw.vue'
import CommentsView from './components/views/Comments.vue'
import SelfDataView from './components/views/SelfData.vue'
import CommentDetailView from './components/views/CommentDetail.vue'
import AllCommentsView from './components/views/AllComments.vue'
import ReestablecerView from './components/views/Reestablecer.vue'
import PswReestablecidaView from './components/views/PswReestablecida.vue'
import InvoiceDetailView from './components/views/InvoiceDetail.vue'
import ReportsView from './components/views/Reports.vue'
import FinSolicitudView from './components/views/FinSolicitud.vue'
import AllContactsView from './components/views/AllContacts.vue'
import AllProvidersView from './components/views/AllProviders.vue'
import LicitacionesView from './components/views/Licitaciones.vue'
import ManualsView from './components/views/Manuals.vue'
import ContactDetail from './components/views/ContactDetail.vue'
import SubmitDocumentationView from './components/views/SubmitDocumentation.vue'
import AltaDeUsuario from './components/views/AltaDeUsuario.vue'
import ConfirmProvider from './components/views/ConfirmProvider.vue'
import CompanyData from './components/views/CompanyData.vue'
import NewProviders from './components/views/NewProviders.vue'
import ReportTable from './components/views/ReportTable.vue'
import ProviderDetail from './components/views/ProviderDetail.vue'
import AltaDeUsuarioPeru from './components/views/AltaDeUsuarioPeru.vue'
import ConfirmProviderPeru from './components/views/ConfirmProviderPeru.vue'
import NewsView from './components/views/News.vue'
import Prebill from './components/views/Prebill.vue'
import Bill from './components/views/Bill.vue'
// Routes
const routes = [
  {
    path: '/login',
    component: LoginView
  },
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'dashboard',
        alias: '',
        component: DashboardView,
        name: 'Dashboard',
        meta: {description: ''}
      }, {
        path: 'solicitud',
        component: SolicitudView,
        name: 'Solicitud',
        meta: {description: 'de nuevo usuario del Portal'}
      }, {
        path: 'individual',
        component: IndividualView,
        name: 'Individual',
        meta: {description: 'Consulta individual de Factura'}
      // }, {
      //   path: 'logout',
      //   component: ReposView,
      //   name: 'Desconectarse',
      //   meta: {description: 'Desconectarse de la sesión del Portal'}
      }, {
        path: 'search',
        component: SearchView,
        name: 'Búsqueda',
        meta: {description: 'Consulta por filtro'}
      }, {
        path: 'billsManagement',
        component: BillsManagementView,
        name: 'Consulta de Facturas, NC, ND',
        meta: {}
      }, {
        path: 'buyOrders',
        component: BuyOrdersView,
        name: 'OC (Orden de Compra)',
        meta: {}
      }, {
        path: 'toBill',
        component: BuyOrdersView,
        name: 'Ordenes de Compra',
        meta: {}
      }, {
        path: 'paymentManagement',
        component: SearchView,
        name: 'Consulta de facturas',
        meta: {}
      }, {
        path: 'prebill',
        component: Prebill,
        name: 'Precarga de facturas',
        meta: {}
      }, {
        path: 'changePsw',
        component: ChangePswView,
        name: 'Cambiar clave',
        meta: {description: 'Cambio de contraseña'}
      }, {
        path: 'selfdata',
        component: SelfDataView,
        name: 'Mis datos',
        meta: {description: 'Visualice y actualice sus datos'}
      }, {
        path: 'comments',
        component: CommentsView,
        name: 'Actualizar datos',
        meta: {description: 'Envíe un pedido al administrador'}
      }, {
        path: 'commentDetail',
        component: CommentDetailView,
        name: 'Comentario',
        meta: {description: 'Detalles del comentario'}
      }, {
        path: 'allComments',
        component: AllCommentsView,
        name: 'Mensajes'
      }, {
        path: 'reestablecer',
        component: ReestablecerView,
        name: 'Reestablecer contraseña',
        meta: {description: ''}
      }, {
        path: 'pswreestablecida',
        component: PswReestablecidaView,
        name: 'Clave Reestablecida',
        meta: {description: ''}
      }, {
        path: 'invoicedetail',
        component: InvoiceDetailView,
        name: 'Ordenes de Compra',
        meta: {description: 'Detalles'}
      }, {
        path: 'reports',
        component: ReportsView,
        name: 'Reportes',
        meta: {description: ''}
      }, {
        path: 'finSolicitud',
        component: FinSolicitudView,
        name: 'FinSolicitud',
        meta: {description: 'Finalizar registro'}
      }, {
        path: 'contacts',
        component: AllContactsView,
        name: 'Contactos',
        meta: {description: ''}
      }, {
        path: 'providers',
        component: AllProvidersView,
        name: 'Proveedores',
        meta: {description: ''}
      }, {
        path: 'compulsas',
        component: LicitacionesView,
        name: 'Compulsas',
        meta: {description: ''}
      }, {
        path: 'manuals',
        component: ManualsView,
        name: 'Instructivos',
        meta: {description: ''}
      }, {
        path: 'news',
        component: NewsView,
        name: 'Noticias',
        meta: {description: ''}
      },
      {
        path: 'submitDocumentation',
        component: SubmitDocumentationView,
        name: 'Presentar Documentación',
        meta: {description: ''}
      },
      {
        path: 'contactDetail',
        component: ContactDetail,
        name: 'Detalle del Contacto',
        meta: {description: ''}
      },
      {
        path: 'userActivationAR',
        component: AltaDeUsuario,
        name: 'Proveedores',
        meta: {description: ''}
      },
      {
        path: 'userActivationPE',
        component: AltaDeUsuarioPeru,
        name: 'Proveedores Peru',
        meta: {description: ''}
      },
      {
        path: 'newProviders',
        component: NewProviders,
        name: 'Alta de proveedor',
        meta: {description: ''}
      },
      {
        path: 'ProvidersTable',
        component: ReportTable,
        name: 'Reporte de proveedores',
        meta: {description: ''}
      },
      {
        path: 'providerDetail/:id',
        component: ProviderDetail,
        name: 'Detalles del proveedor',
        meta: {description: ''}
      },
      {
        path: 'confirmProvider/:country(AR|PE)/:id',
        component: ConfirmProvider,
        name: 'Confirmar proveedor',
        meta: {description: ''}
      },
      {
        path: 'companyData/:id/:step/:country',
        component: CompanyData,
        name: 'Datos de la Compañia',
        meta: {description: ''}
      },
      {
        path: 'confirmProviderPeru/:country/:id',
        component: ConfirmProviderPeru,
        name: 'Confirmar proveedor',
        meta: {description: ''}
      },
      {
        path: 'bill/:id',
        component: Bill,
        name: '',
        meta: {description: ''}
      }
    ]
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js